import React from 'react';
import { PropInfo, CodeExample, ButtonGroupProps } from '@cimpress/react-components';
import ButtonGroupCode from '!raw-loader!./buttonGroup.jsx';
import ButtonGroupDemo from './buttonGroup.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const ButtonGroupDocs = () => {
  const propInfos: PropInfo<ButtonGroupProps>[] = [
    {
      name: 'variant',
      type: 'string',
      default: '',
      description: (
        <div>
          The variant of button group that you are creating, providing one of the following values:
          <ul>
            <li>justified</li>
            <li>vertical</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <ComponentDoc<ButtonGroupProps> name="Button Group" propInfos={propInfos}>
      <ButtonGroupDemo />
      <CodeExample code={ButtonGroupCode} />
    </ComponentDoc>
  );
};

export default ButtonGroupDocs;
